import { useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BarChart3, Activity, PhoneOutgoing, CalendarHeart, PartyPopper, MessageCircleQuestion, Library, FileSpreadsheet, Inbox, Megaphone } from "lucide-react";
import Analytics from "@/pages/Analytics";
import AdminAudit from "@/pages/AdminAudit";
import VoiceCalls from "@/pages/VoiceCalls";
import TutorReview from "@/pages/TutorReview";
import Requests from "@/pages/Requests";
import TeacherTuitionLibrary from "@/pages/TeacherTuitionLibrary";
import TeacherUtility from "@/pages/TeacherUtility";
import EventsList from "@/components/EventsList";
import HolidaysList from "@/components/HolidaysList";
import Announcements from "@/pages/Announcements";

const VALID_TABS = ["analytics", "announcements", "tuition-library", "utility", "requests", "audit", "calls", "tutor-review", "events", "holidays"];

export default function TeacherAnalysis() {
  const [params, setParams] = useSearchParams();
  const requested = params.get("tab");
  const active = VALID_TABS.includes(requested) ? requested : "analytics";
  const onChange = (val) => setParams({ tab: val }, { replace: true });

  return (
    <Layout>
      <div className="space-y-6" data-testid="more-info-page">
        <Tabs value={active} onValueChange={onChange} className="w-full">
          <TabsList className="h-auto flex-wrap gap-1 bg-slate-100 dark:bg-slate-800/60" data-testid="more-info-tabs">
            <TabsTrigger value="analytics" data-testid="more-info-tab-analytics" className="gap-1.5">
              <BarChart3 className="h-4 w-4" /> Analytics
            </TabsTrigger>
            <TabsTrigger value="announcements" data-testid="more-info-tab-announcements" className="gap-1.5">
              <Megaphone className="h-4 w-4" /> Announcements
            </TabsTrigger>
            <TabsTrigger value="tuition-library" data-testid="more-info-tab-tuition-library" className="gap-1.5">
              <Library className="h-4 w-4" /> Tuition Library
            </TabsTrigger>
            <TabsTrigger value="utility" data-testid="more-info-tab-utility" className="gap-1.5">
              <FileSpreadsheet className="h-4 w-4" /> Utility
            </TabsTrigger>
            <TabsTrigger value="requests" data-testid="more-info-tab-requests" className="gap-1.5">
              <Inbox className="h-4 w-4" /> Requests
            </TabsTrigger>
            <TabsTrigger value="audit" data-testid="more-info-tab-audit" className="gap-1.5">
              <Activity className="h-4 w-4" /> Activity Audit
            </TabsTrigger>
            <TabsTrigger value="calls" data-testid="more-info-tab-calls" className="gap-1.5">
              <PhoneOutgoing className="h-4 w-4" /> Calls
            </TabsTrigger>
            <TabsTrigger value="tutor-review" data-testid="more-info-tab-tutor-review" className="gap-1.5">
              <MessageCircleQuestion className="h-4 w-4" /> AI Tutor Review
            </TabsTrigger>
            <TabsTrigger value="events" data-testid="more-info-tab-events" className="gap-1.5">
              <CalendarHeart className="h-4 w-4" /> Events
            </TabsTrigger>
            <TabsTrigger value="holidays" data-testid="more-info-tab-holidays" className="gap-1.5">
              <PartyPopper className="h-4 w-4" /> Holidays
            </TabsTrigger>
          </TabsList>

          <TabsContent value="analytics" className="mt-6"><Analytics embedded /></TabsContent>
          <TabsContent value="announcements" className="mt-6"><Announcements embedded /></TabsContent>
          <TabsContent value="tuition-library" className="mt-6"><TeacherTuitionLibrary embedded /></TabsContent>
          <TabsContent value="utility" className="mt-6"><TeacherUtility embedded /></TabsContent>
          <TabsContent value="requests" className="mt-6"><Requests embedded /></TabsContent>
          <TabsContent value="audit" className="mt-6"><AdminAudit embedded /></TabsContent>
          <TabsContent value="calls" className="mt-6"><VoiceCalls embedded /></TabsContent>
          <TabsContent value="tutor-review" className="mt-6"><TutorReview embedded /></TabsContent>
          <TabsContent value="events" className="mt-6">
            <div className="mb-4">
              <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">School events</h2>
              <p className="text-sm text-slate-500 dark:text-slate-400">Upcoming and past events for this year.</p>
            </div>
            <EventsList />
          </TabsContent>
          <TabsContent value="holidays" className="mt-6">
            <div className="mb-4">
              <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Holidays</h2>
              <p className="text-sm text-slate-500 dark:text-slate-400">School holiday calendar for this year.</p>
            </div>
            <HolidaysList />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
